import axiosInstance from '@/config/axios';
import type { Chat, PaginatedMessages, Reaction, ReactionType } from '@/types/chats';

export const fetchMyChats = async (): Promise<Chat[]> => {
  const { data } = await axiosInstance.get<Chat[]>('/user/chats');
  return data;
};

export const fetchChatMessages = async (
  chatId: string,
  limit = 50,
  cursor?: string,
  search?: string,
): Promise<PaginatedMessages> => {
  const { data } = await axiosInstance.get<PaginatedMessages>(`/user/chats/${chatId}/messages`, {
    params: { limit, ...(cursor ? { cursor } : {}), ...(search ? { search } : {}) },
  });
  return data;
};

export const markAsRead = async (messageIds: string[]): Promise<void> => {
  await axiosInstance.post(`/user/chats/read-by-ids`, { messageIds });
};

export const markAllRead = async (chatId: string): Promise<void> => {
  await axiosInstance.post(`/user/chats/${chatId}/read`);
};

export const toggleReaction = async (
  messageId: string,
  type: ReactionType,
): Promise<Reaction | null> => {
  const { data } = await axiosInstance.post<Reaction | null>(
    `/user/messages/${messageId}/reactions`,
    { type },
  );
  return data;
};
